import React from 'react';
import IconItem from 'components/Item/IconItem/IconItem';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './MigrationModal.scss';

type Props = {
  setOpenModal: (e: boolean) => void;
};

const MigrationModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="migration-modal">
      <div className="close migration-modal-close">
        <IconItem icon={faClose} onClick={() => { props.setOpenModal(false); }} />
      </div>
      <div className="migration-modal-body">
        <div className="migration-modal-content">
          <div className="migration-title">
            {t('migration_modal.title')}
          </div>
          <div className="migration-message">
            <p>{t('migration_modal.p1')}</p>
            <p>{t('migration_modal.p2')}</p>
            <p>{t('migration_modal.p3')}</p>
            <div className="migration-date">
              <strong>{t('migration_modal.date')}</strong>
            </div>
            <p>{t('migration_modal.p4')}</p>
            <p>{t('migration_modal.p5')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

MigrationModal.displayName = 'MigrationModal';

export default MigrationModal; 